import { render, staticRenderFns } from "./List-vacinacao.vue?vue&type=template&id=9a692f0c&"
import script from "./List-vacinacao.vue?vue&type=script&lang=js&"
export * from "./List-vacinacao.vue?vue&type=script&lang=js&"
import style0 from "./List-vacinacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports